import { apiFetch, buildQuery } from "./client";
import type { Page } from "./admin";
import type { AttachmentEntityKind } from "./attachments";

/** Sprint 4 contract: docs/api/sprint4-sabloni-prilozi-komentari.md §4. */

export type CommentView = {
  id: string;
  entityKind: AttachmentEntityKind;
  entityId: string;
  authorId: string;
  authorName: string;
  body: string;
  createdAt: string;
  /** Author or ADMIN. */
  canDelete: boolean;
};

/** `body` 1..4000 characters. */
export type CommentRequest = { entityKind: AttachmentEntityKind; entityId: string; body: string };

export const COMMENT_MAX_LENGTH = 4000;

export type CommentListParams = {
  entityKind: AttachmentEntityKind;
  entityId: string;
  page?: number;
  size?: number;
};

export const commentsApi = {
  /** `createdAt DESC`. */
  list: (params: CommentListParams) =>
    apiFetch<Page<CommentView>>(`/comments${buildQuery(params)}`),
  /** 201. */
  create: (body: CommentRequest) =>
    apiFetch<CommentView>("/comments", { method: "POST", body }),
  /** 204 (soft); 403 unless author or ADMIN. */
  remove: (id: string) => apiFetch<void>(`/comments/${id}`, { method: "DELETE" }),
};
